module.exports = __webpack_public_path__ + "static/img/payment-status-dialog-bg.778abb4d.webp";